module.exports = __webpack_public_path__ + "img/67_12.f9cb631f.png";